import React from "react";
import styled from "styled-components";
import { number } from "prop-types";
import { motion } from "framer-motion";

const Logo = styled(motion.svg)`
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -30%);
`;

const CitroenMark = ({ width = 20, height = 29 }) => (
  <Logo
    width={width}
    height={height}
    viewBox="0 0 65 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      d="M33.7752 17.0079C27.3752 15.4079 9.27516 29.6745 2.27516 36.5079C1.60849 34.0079 0.475156 28.5079 1.27516 26.5079C2.27516 24.0079 25.2751 0.507872 31.7751 1.00787C38.2751 1.50787 63.2751 23.5079 63.7751 26.5079C64.1751 28.9079 62.9418 34.1745 62.2752 36.5079C54.9418 31.0079 40.1752 18.6079 33.7752 17.0079Z"
      stroke="white"
      strokeWidth="2"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.4, delay: 0.6 }}
    />
    <motion.path
      d="M1 28C13.9836 10.8706 26.4098 3.69935 31 2V7.60784C26.6721 7.2 9.19672 21.0327 1 28Z"
      fill="white"
      stroke="white"
      initial={{ fill: "rgba(255, 255, 255, 0)", pathLength: 0 }}
      animate={{ fill: "rgba(255, 255, 255, 1)", pathLength: 1 }}
      transition={{ duration: 0.5, delay: 0.9 }}
    />
    <motion.path
      d="M33.7752 38.0079C27.3752 36.4079 9.27516 50.6745 2.27516 57.5079C1.60849 55.0079 0.475156 49.5079 1.27516 47.5079C2.27516 45.0079 25.2751 21.5079 31.7751 22.0079C38.2751 22.5079 63.2751 44.5079 63.7751 47.5079C64.1751 49.9079 62.9418 55.1745 62.2752 57.5079C54.9418 52.0079 40.1752 39.6079 33.7752 38.0079Z"
      stroke="white"
      strokeWidth="2"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 0.4, delay: 0.6 }}
    />
    <motion.path
      d="M1 49C13.9836 31.8706 26.4098 24.6993 31 23V28.6078C26.6721 28.2 9.19672 42.0327 1 49Z"
      fill="white"
      stroke="white"
      initial={{ fill: "rgba(255, 255, 255, 0)", pathLength: 0 }}
      animate={{ fill: "rgba(255, 255, 255, 1)", pathLength: 1 }}
      transition={{ duration: 1, delay: 0.9 }}
    />
  </Logo>
);

CitroenMark.propTypes = {
  height: number,
  width: number,
};
export default CitroenMark;
